import { ReactNode } from 'react';
import styles from './styles.module.scss';

interface IModalHeaderProps {
  title?: string;
  text?: string;
  children?: ReactNode;
}

export const ModalHeader = ({ title, text, children }: IModalHeaderProps) => (
  <div className={styles.header}>
    {(title || text) && (
      <div>
        {title && <h3 className={styles.heading}>{title}</h3>}
        {children && <div className={styles.content}>{children}</div>}
      </div>
    )}
  </div>
);
